import { render, staticRenderFns } from "./proposalFee.vue?vue&type=template&id=563e8df2"
import script from "./proposalFee.vue?vue&type=script&lang=js"
export * from "./proposalFee.vue?vue&type=script&lang=js"
import style0 from "./proposalFee.vue?vue&type=style&index=0&id=563e8df2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports